import React from "react";
import Element from "./Element";
import { EducationType, RewardType, WorkExperienceType } from "../../types";

export type ElementDataType = EducationType | RewardType | WorkExperienceType;

export interface ElementsListProps {
  data: ElementDataType[];
  renderElement(item: ElementDataType): React.ReactNode;
  onEdit(index: number): void;
  onRemove(index: number): void;
  editIndex: number | null;
}

export interface ElementsListState {}

export const ElementsList = (props: ElementsListProps) => {
  const { data, renderElement, onEdit, onRemove, editIndex } = props;
  return (
    <div className="elements-list">
      {data.map((item: ElementDataType, index: number) => (
        <Element
          key={index}
          index={index}
          onEdit={onEdit}
          onRemove={onRemove}
          editIndex={editIndex}
        >
          {renderElement(item)}
        </Element>
      ))}
    </div>
  );
};

export default ElementsList;
